export function AllyMascotIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <path
        fill='currentColor'
        d='m28.61,22.27h.01l-4.37-4.75c-6.17.95-13.88-.64-17.07,4.04-.19.27-1.01,1.64-2.34,3.53-1.21,1.71-2.26,3.05-2.96,3.91,1.96-.48,3.09-1.37,3.65-1.9.9-.86,1.7-2.08,2.22-2.87.21-.32.39-.61.55-.88v5.46c-1,1.49-2.01,2.99-3.01,4.48.3,1.89.61,3.79.91,5.68,2.79.81,3.8,0,1.42-1.67-1.29-3.17,6.18-7.75,7.67-9.69,2.76.89,6.35,1.69,10.57,1.71.96,0,1.87-.04,2.74-.11v-6.92Z'
      />
      <path
        fill='currentColor'
        d='m34.56,37.19c-.15-2.15-.14-4.86.36-7.95.38-2.35.96-4.38,1.55-6.06l-6.67.08h0v5.85c.78,2.75,1.74,5.61,2.95,8.53.2.48.4.96.61,1.43,1.39.46,2.49.29,2.65-.13.16-.39-.45-1.15-1.45-1.76Z'
      />
      <path
        fill='currentColor'
        d='m30.05,22.1l5.47-.07-5.98-6.51c-1.13.87-2.47,1.4-3.93,1.74l4.45,4.84Z'
      />
      <path
        fill='currentColor'
        d='m24.26,17.51l-7.17-7.89c-.15-.17-.19-.42-.1-.63.09-.21.3-.35.53-.35h7.03c.16,0,.32.07.43.19l5.41,5.89c-.13.13-.27.25-.41.38-.15.14-.3.27-.45.41-1.75-1.9-3.49-3.8-5.24-5.7h-5.46l6.76,7.43c-.23.06-.46.11-.71.16-.21.04-.42.08-.62.11Z'
      />
      <path
        fill='currentColor'
        d='m45.65,12.4c-1.34-.48-2.56-1.25-3.51-2.29-.64-.69-.96-.94-1.24-1.05-.28-.12-.53-.16-.71-.19-1.24-.17-3.01-.01-3.57.04-4.13,3.86-5.97,5.57-6.03,5.63,0,0-.04.04-.1.09-.03.03-.07.06-.1.09l6.58,7.17c.36-.85.73-1.63,1.09-2.33.36-.7.62-1.13,1.05-1.86.28-.48.7-1.2,1.21-2.1,1.06-.18,1.92-.3,2.49-.37,1.31-.17,1.81-.18,2.38-.6.22-.16.65-.77.88-1.43.11-.33-.09-.68-.42-.79Zm-6.23,1.22c-.8,1.61-2.33,1.87-2.5,1.9l-.21.03-.17-.13c-.32-.26-.88-.84-1.04-1.88-.12-.74.02-1.4.16-1.82.09-.26.36-.4.63-.32.26.09.4.37.31.63-.1.32-.21.81-.12,1.35.08.54.32.89.51,1.1.36-.11,1.1-.43,1.54-1.31.36-.71.33-1.4.3-1.67-.03-.27.17-.52.44-.55.26-.02.52.17.54.44.05.44.06,1.31-.4,2.22Zm2.31-.8c-.33,0-.61-.27-.61-.61s.27-.61.61-.61.61.27.61.61-.27.61-.61.61Z'
      />
    </svg>
  );
}
